// extracted by mini-css-extract-plugin
export var active = "_gt-2";
export var recordingDot = "_gt-1";
export var recordingIndicator = "_gt-0";